<template>
    <div class="login-container">
        <img :src="'static/images/'+bgImg+'.jpg'" class="bg">
        
        <el-form :model="user" status-icon ref="user" label-position="left" label-width="0px" class="login-page">
            <div class="login-title"><i slot="prefix" class="el-icon-user" style="font-size:30px; margin-right:10px"></i>可易云.库存系统</div>
            <el-form-item>
                <el-input ref="inputCompanyName" v-model="user.companyname" auto-complete="off" placeholder="请输入已注册的单位名称" @keydown.enter.native="nextFocus('inputUserName')">
                    <i slot="prefix" class="el-icon-office-building"></i>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-input ref="inputUserName" v-model="user.username" auto-complete="off" placeholder="请输入用户名 (初始为 admin)" @keydown.enter.native="nextFocus('inputPwd')">
                    <i slot="prefix" class="el-icon-user"></i>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-input type="password" ref="inputPwd" v-model="user.password" auto-complete="off" placeholder="请输入密码 (初始为 123)" @keydown.enter.native="login">
                    <i slot="prefix" class="el-icon-lock"></i>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-link :underline="false" type="primary" style="color:#2f54eb" @click="demoClick()">免费登陆</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" type="primary" style="color:#2f54eb" @click="doRegister()">注册账户</el-link>
                <el-link :underline="false" type="primary" style="color:#2f54eb; float:right" href="http://www.fkerp.com" target="_bank">官方网站</el-link>
                <el-link :underline="false" type="primary" icon="el-icon-headset" style="color:#2f54eb; float:right; margin-right:20px"
                    href="tencent://message/?uin=2455247199&Site=qq&Menu=yes" target="_bank">在线顾问</el-link>
                <el-button type="primary" class="my-button-primary" style="margin-top:10px; font-size:16px; height:45px; width:100%; border-radius:100px" @click="login"
                    :loading="logining">登 录</el-button>
                <el-link :underline="false" class="my-button-default"
                    style="background-color:#ecf3ff;margin-top:10px; font-size:16px; height:45px; width:100%; border-radius:100px " href="http://www.fkerp.com/soft/kcSetup.zip">
                    安装到桌面</el-link>
            </el-form-item>
            
        </el-form>
    </div>
</template>

<script>
import common from '../../utils/common';

export default {
    data() {
        return {
            bgImg: Math.round(Math.random()*4 + 1),
            logining: false,
            user: {
                companyname: "",
                username: "",
                password: "",
            }
        }
    },
    
    mounted() {
        try {
            let self = this;
            
            this.$refs.inputCompanyName.focus();
            const loginUser = JSON.parse(localStorage.getItem('loginUser'));
            if (loginUser) {
                this.user.companyname = common.toStrAndTrim(loginUser.companyName);
                this.user.username = common.toStrAndTrim(loginUser.userName);
                this.$refs.inputPwd.focus();
            }
            
            //需延时才能获得
            setTimeout(function () {
                const companyname = self.$route.query.companyname;
                const username = self.$route.query.username;
                const password = self.$route.query.password;
                
                if (companyname && username && password) {
                    self.user.companyname = common.toStrAndTrim(companyname);
                    self.user.username = common.toStrAndTrim(username);
                    self.user.password = common.toStrAndTrim(password);
                }
                
            }, 100);
            
        }
        catch (err) {
            console.log(err);
        }
    },
    
    methods: {
        nextFocus(nextRef) {
            this.$refs[nextRef].focus();
        },
        
        canLogin() {
            if (common.toStrAndTrim(this.user.companyname) === '') {
                common.msgError('请输入公司名称');
                this.$refs.inputCompanyName.focus();
                return false;
            }
            
            if (common.toStrAndTrim(this.user.username) === '') {
                common.msgError('请输入用户名');
                this.$refs.inputUserName.focus();
                return false;
            }
            
            if (common.toStrAndTrim(this.user.password) === '') {
                common.msgError('请输入密码');
                this.$refs.inputPwd.focus();
                return false;
            }
            return true;
        },
        
        demoClick() {
            this.user.companyname = '演示公司';
            this.user.username = 'admin';
            this.user.password = '123';
            this.login();
        },
        
        doRegister() {
            this.$router.push({ path: "/register" });
        },
        
        async login() {
            try {
                if (!this.canLogin()) return false;
                
                this.logining = true;
                const res = await this.$axios.post(common.serverApi('login'), this.user);
                if (res.data.code !== 1000 && res.data.code !== 1004) {
                    console.log(res.data);
                    common.msgError(res.data.message);
                    return false;
                }
                
                if (res.data.code === 1004) {
                    common.msgPopInfo(res.data.message);
                }
                
                //保存登陆信息 token等
                const result = JSON.stringify(res.data.result);
                sessionStorage.setItem('userInfo', result);
                
                //获得系统信息表
                const res2 = await this.$axios.get(common.serverApi('sys'));
                if (res2.data.code !== 1000) {
                    console.log(res2.data);
                    sessionStorage.clear();
                    common.msgError(res2.data.message);
                    return false;
                }
                
                //获得默认信息表
                const res3 = await this.$axios.get(common.serverApi('default'));
                if (res3.data.code !== 1000) {
                    console.log(res3.data);
                    sessionStorage.clear();
                    common.msgError(res3.data.message);
                    return false;
                }
                
                //获得权限表
                const res4 = await this.$axios.get(common.serverApi('getrole'));
                if (res4.data.code !== 1000) {
                    console.log(res4.data);
                    sessionStorage.clear();
                    common.msgError(res4.data.message);
                    return false;
                }
                
                //保存全局数据
                const result2 = JSON.stringify(res2.data.result[0]);
                sessionStorage.setItem('sysInfo', result2);
                
                const result3 = JSON.stringify(res3.data.result[0]);
                sessionStorage.setItem('default', result3);
                
                const result4 = JSON.stringify(res4.data.result);
                sessionStorage.setItem('roleInfo', result4);
                
                //保存用户登陆信息
                localStorage.removeItem('loginUser');
                const loginUser = { companyName: this.user.companyname, userName: this.user.username }
                localStorage.setItem('loginUser', JSON.stringify(loginUser));
                
                //登陆日志
                await this.$axios.post(common.serverApi('loginlog'), this.user);
                
                //跳到首页
                const homeMenu = {
                    id: "0",
                    path: "/home",
                    name: "home",
                    title: "首页",
                }
                this.$router.push({ path: homeMenu.path });
                this.$store.commit('addTag', homeMenu);
            }
            catch (err) {
                console.log(err);
                sessionStorage.clear();
                common.msgError('登陆异常')
                return false;
            }
            finally {
                this.logining = false;
            }
        }
    }
};

</script>



// WEBPACK FOOTER //
// src/components/user/login.vue